import { MATCH_ANY_PARAMETERS } from 'wildcard-mock-link';
import { WhereIsMyStringDocument } from 'src/generated/graphql';

// Mock response data for WhereIsMyString query - exported for test assertions
export const whereIsMyStringMockData = {
  whereIsMyString: {
    localizedContent: {
      content: 'Test localized content value',
      contentId: 'test-content-id-123',
      contentDebugModeMetadata: {
        tmsName: 'TestTMS',
        marketplace: 'US',
        cmsName: 'TestCMS',
        locale: 'en_US',
        contentStage: 'PRODUCTION',
        version: '1.0.0',
      },
    },
    errorResponse: null,
  },
};

// Mock for WhereIsMyString query used in the WIMS (Where Is My String) page
export const whereIsMyStringMock = (async () => {
  return {
    request: {
      query: WhereIsMyStringDocument,
      variables: MATCH_ANY_PARAMETERS,
    },
    result: {
      data: whereIsMyStringMockData,
    },
  };
})();
